import React from 'react';
import Moment from 'moment';
import ReactPlayer from 'react-player';
import ReactMarkdown from 'react-markdown';
import VideoThumbnail from './VideoThumbnail';
import {
  getCurrentExperience,
  visibilityAllowsExperience,
} from '../../utils/visibility';

function getExperience() {
  return getCurrentExperience();
}

function isVisibleByExperience(item) {
  const experience = getExperience();
  return visibilityAllowsExperience(item && item.visibilityValue, experience);
}

function getDetailsText(item) {
  return item?.description || item?.file?.description || '';
}

function shouldShowDetails(item) {
  // Keep explicit "false" behavior, but default to showing details otherwise.
  return item?.showDetails !== false;
}

function QueryGallery({ gallery, selectedMonth, selectedYear, selectedGroup }) {
  // Defensive copy + visibility filter
  let items = (gallery.items || []).filter(isVisibleByExperience);

  if (selectedMonth) {
    items = items.filter((item) => Moment(item.releaseDate).month() === parseInt(selectedMonth));
  }

  if (selectedYear) {
    items = items.filter((item) => Moment(item.releaseDate).year() === parseInt(selectedYear));
  }

  if (selectedGroup) {
    items = items.filter(() => gallery.groupName === selectedGroup);
  }

  if (items.length === 0) {
    return (
      <div className="news-section">
        <p>No items match the selected criteria.</p>
      </div>
    );
  }

  return (
    <div className="news-section">
      <div className="section-content row cubs-news">
        {items.map((item, itemIndex) =>
          item.featuredVideo === true && item.name === 'Our Vision, Mission and Values' ? null : (
            <div key={itemIndex} className="col md-6 flex-item gallery-item">
              {ReactPlayer.canPlay(item?.file?.url || '') ? (
                <>
                  <div className="news-img-container">
                    <div className="player-wrapper">
                      <ReactPlayer
                        config={{ file: { attributes: { controlsList: 'nodownload' } } }}
                        id={item.name}
                        className="react-player"
                        onStart={() =>
                          window.dataLayer &&
                          window.dataLayer.push({ event: 'gallery_video_start', video_name: item.name })
                        }
                        onEnded={() =>
                          window.dataLayer &&
                          window.dataLayer.push({ event: 'gallery_video_end', video_name: item.name })
                        }
                        controls={true}
                        light={
                          (item?.file?.url || '').includes('videos') ? (
                            <VideoThumbnail
                              videoUrl={item.file.url}
                              thumbnailHandler={(thumbnail) => thumbnail}
                              snapshotAtTime={item.snapshotTime}
                            />
                          ) : true
                        }
                        muted={true}
                        width="100%"
                        height="100%"
                        url={item.file.url}
                      />
                    </div>
                  </div>

                  {shouldShowDetails(item) && (
                    <>
                      <h3>
                        <b>{item.name}</b>
                      </h3>
                      <p>{Moment.utc(item.releaseDate).format('MM/DD/YYYY')}</p>
                      <ReactMarkdown className="black news-markdown" children={getDetailsText(item)} />
                    </>
                  )}
                </>
              ) : (
                <>
                  <div className="news-img-container">
                    {item.openableFileLink ? (
                      <a href={item.file.url} target="_blank" rel="noopener noreferrer">
                        <div className="player-wrapper">
                          <img
                            src={item.fileThumbnailOverride?.url ? item.fileThumbnailOverride.url : item.file.url}
                            alt="news"
                          />
                        </div>
                      </a>
                    ) : (
                      <div className="player-wrapper">
                        <img
                          src={item.fileThumbnailOverride?.url ? item.fileThumbnailOverride.url : item.file.url}
                          alt="news"
                        />
                      </div>
                    )}
                  </div>

                  {shouldShowDetails(item) && (
                    <>
                      <h3>
                        <b>{item.name}</b>
                      </h3>
                      <p>{Moment.utc(item.releaseDate).format('MM/DD/YYYY')}</p>
                      <ReactMarkdown className="black news-markdown" children={getDetailsText(item)} />
                    </>
                  )}
                </>
              )}
            </div>
          )
        )}
      </div>
    </div>
  );
}

export default QueryGallery;
